import { makeStyles } from '@material-ui/styles';
import { MainButton } from '@bizzabo/design-system';
import cn from 'clsx';
import LoaderSpinner from '../../../../people/components/LoaderSpinner';

interface LoaderButtonArgs extends React.ComponentProps<typeof MainButton> {
    children?: React.ReactNode;
    isLoading?: boolean;
    icon?: React.ReactNode;
}

const LoaderButton: React.FC<LoaderButtonArgs> = ({
    children,
    isLoading,
    icon,
    className,
    disabled,
    ...otherProps
}) => {
    const classes = useStyles();
    return (
        <MainButton
            size="large"
            variant="fillPrimary"
            className={cn(className, classes.loaderButton)}
            disabled={disabled || isLoading}
            {...otherProps}
        >
            {isLoading ? <LoaderSpinner className={classes.loader} /> : children}
            {!isLoading && icon && <div className={classes.submitIcon}>{icon}</div>}
        </MainButton>
    );
};

const useStyles = makeStyles(
    () => ({
        loaderButton: {
            position: 'relative',
            padding: 4,
            height: 28,
            '& > div': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
        },
        submitIcon: {
            position: 'absolute',
            right: '10%',
            height: 20,
            fontSize: 20,
        },
        loader: {
            fontSize: 17,
        },
    }),
    { classNamePrefix: 'loader-button' }
);

export default LoaderButton;
